export const nodalOfficersRoleMap = {
  tifc: {
    value: "1",
    label: "TIFC",
    name: "TIFC",
    defaultPath: "/admin/tifc/applications",
  },
  dlct: {
    value: "2",
    label: "DLCT",
    name: "DLCT",
    defaultPath: "/admin/dlct/applications",
  },
  slac: {
    value: "3",
    label: "SLAC",
    name: "SLAC",
    defaultPath: "/admin/slac/applications",
  },
  ddo: {
    value: "4",
    label: "DDO",
    name: "DDO",
    defaultPath: "/admin/ddo/applications",
  },
  hod: {
    value: "6",
    label: "HOD",
    name: "HOD",
    defaultPath: "",
  },
};

export const nodalOfficersRoleList = Object.values(nodalOfficersRoleMap);

export const stateOfficerRoleMap = {
  tifc: {
    value: "1",
    label: "TIFC",
    name: "TIFC",
  },
  slac: {
    value: "3",
    label: "SLAC",
    name: "SLAC",
  },
  ddo: {
    value: "4",
    label: "DDO",
    name: "DDO",
  },
  hod: {
    value: "6",
    label: "HOD",
    name: "HOD",
  },
};

export const districtOfficerRoleMap = {
  dlct: {
    value: "2",
    label: "DLCT",
    name: "DLCT",
  },
};

export const stateOfficerRoleList = Object.values(stateOfficerRoleMap);
export const districtOfficerRoleList = Object.values(districtOfficerRoleMap);

export const officersDocumentTypeMap = {
  // CAPITAL SUBSIDY (Incentive Claim ID = 1)
  capital_subsidy: {
    tifc_verified: "tifc_verified_report_capital_subsidy",
    tifc_unverified: "tifc_unverified_report_capital_subsidy",
    dlct_verified: "dlct_verified_report_capital_subsidy",
    dlct_unverified: "dlct_unverified_report_capital_subsidy",
    slac_approved: "slac_approved_report_capital_subsidy",
    slac_rejected: "slac_rejection_report_capital_subsidy",
  },

  // INTEREST ASSISTANCE (Incentive Claim ID = 2)
  interest_assistance: {
    1: {
      tifc_verified: "tifc_verified_report_interest_assistance_first_installment",
      tifc_unverified: "tifc_unverified_report_interest_assistance_first_installment",
      slac_approved: "slac_approved_report_interest_assistance_first_installment",
      slac_rejected: "slac_rejection_report_interest_assistance_first_installment",
    },
    2: {
      tifc_verified: "tifc_verified_report_interest_assistance_second_installment",
      tifc_unverified: "tifc_unverified_report_interest_assistance_second_installment",
      slac_approved: "slac_approved_report_interest_assistance_second_installment",
      slac_rejected: "slac_rejection_report_interest_assistance_second_installment",
    },
    3: {
      tifc_verified: "tifc_verified_report_interest_assistance_third_installment",
      tifc_unverified: "tifc_unverified_report_interest_assistance_third_installment",
      slac_approved: "slac_approved_report_interest_assistance_third_installment",
      slac_rejected: "slac_rejection_report_interest_assistance_third_installment",
    },
  },
};

export const statusToStageMap = {
  "1": "tifc_unverified",
  "2": "tifc_unverified",
  "3": "tifc_verified",
  "4": "dlct_unverified",
  "5": "dlct_verified",
  "6": "slac_rejected",
  "7": "slac_approved",
};

export const nodalOfficerDocumentTypeIdMap = {
  tifc_verified_report_capital_subsidy: "TIFC Verified Report - Capital Subsidy",
  tifc_unverified_report_capital_subsidy: "TIFC Unverified Report - Capital Subsidy",
  dlct_verified_report_capital_subsidy: "DLCT Verified Report - Capital Subsidy",
  dlct_unverified_report_capital_subsidy: "DLCT Unverified Report - Capital Subsidy",
  slac_approved_report_capital_subsidy: "SLAC Approved Report - Capital Subsidy",
  slac_rejection_report_capital_subsidy: "SLAC Rejection Report - Capital Subsidy",
  tifc_verified_report_interest_assistance_first_installment: "TIFC Verified Report - Interest Subsidy First Installment",
  tifc_unverified_report_interest_assistance_first_installment: "TIFC Unverified Report - Interest Subsidy First Installment",
  slac_approved_report_interest_assistance_first_installment: "SLAC Approved Report - Interest Subsidy First Installment",
  slac_rejection_report_interest_assistance_first_installment: "SLAC Rejection Report - Interest Subsidy First Installment",
  tifc_verified_report_interest_assistance_second_installment: "TIFC Verified Report - Interest Subsidy Second Installment",
  tifc_unverified_report_interest_assistance_second_installment: "TIFC Unverified Report - Interest Subsidy Second Installment",
  slac_approved_report_interest_assistance_second_installment: "SLAC Approved Report - Interest Subsidy Second Installment",
  slac_rejection_report_interest_assistance_second_installment: "SLAC Rejection Report - Interest Subsidy Second Installment",
  tifc_verified_report_interest_assistance_third_installment: "TIFC Verified Report - Interest Subsidy Third Installment",
  tifc_unverified_report_interest_assistance_third_installment: "TIFC Unverified Report - Interest Subsidy Third Installment",
  slac_approved_report_interest_assistance_third_installment: "SLAC Approved Report - Interest Subsidy Third Installment",
  slac_rejection_report_interest_assistance_third_installment: "SLAC Rejection Report - Interest Subsidy Third Installment",
  sanction_order_capital_subsidy_first_installment: "Sanction Order Capital Subsidy First Installment",
  sanction_order_capital_subsidy_second_installment: "Sanction Order Capital Subsidy Second Installment",
  sanction_order_interest_assistance_first_installment: "Sanction Order Interest Assistance First Installment",
  sanction_order_interest_assistance_second_installment: "Sanction Order Interest Assistance Second Installment",
  sanction_order_interest_assistance_third_installment: "Sanction Order Interest Assistance Third Installment",
  transaction_reference_capital_subsidy_first_installment: "Transaction Reference Capital Subsidy First Installment",
  transaction_reference_capital_subsidy_second_installment: "Transaction Reference Capital Subsidy Second Installment",
  transaction_reference_interest_assistance_first_installment: "Transaction Reference Interest Assistance First Installment",
  transaction_reference_interest_assistance_second_installment: "Transaction Reference Interest Assistance Second Installment",
  transaction_reference_interest_assistance_third_installment: "Transaction Reference Interest Assistance Third Installment",
};

export const interestAssistanceDocs = {
  bank_financial_institution_loan_sanction_letter: "Bank / financial Institution’s loan sanction letter (only NBFCs and Scheduled Banks)",
  proof_payment_interest_principal_bank: "Proof of payment of interest and principal amount to bank",
  bank_certificate_annual_interest_payment: "Bank certificate stating annual interest payment and Bank Certificate for No Default & towards repayment of loan",
};


import { applicationStatusMap } from "./applicationStatusConfig";

export const nodalOfficerConfigs = {
  TIFC: {
    statuses: [
      {
        label: "Incomplete Documents/Pending Documents",
        value: applicationStatusMap.incompleteDocumentPending.value,
      },
      {
        label: "Incomplete Information",
        value: applicationStatusMap.incompleteInformation.value,
      },
      {
        label: "Verified",
        value: applicationStatusMap.tifcVerified.value,
      },
    ],
    requiresUpload: () => true, // always required
    uploadLabel: (statusValue) => {
      if (statusValue === applicationStatusMap.tifcVerified.value) {
        return "Upload Verification Report";
      }
      return "Upload Incompletion Report";
    },
  },
  DLCT: {
    statuses: [
      {
        label: "Unverified",
        value: applicationStatusMap.dlctUnverified.value,
      },
      {
        label: "Verified",
        value: applicationStatusMap.dlctVerified.value,
      },
    ],
    requiresUpload: () => true,
    uploadLabel: (statusValue) =>
      statusValue === applicationStatusMap.dlctVerified.value
        ? "Upload Verification Report"
        : "Upload Unverified Report",
  },
  SLAC: {
    statuses: [
      {
        label: "Rejected",
        value: applicationStatusMap.rejected.value,
      },
      {
        label: "Approved",
        value: applicationStatusMap.approved.value,
      },
    ],
    requiresUpload: () => true,
    uploadLabel: (statusValue) =>
      statusValue === applicationStatusMap.rejected.value
        ? "Upload Rejection Report"
        : "Upload Acceptance Report",
  },
  DDO: {

  },
  User: {

  }
};


